module.exports = __webpack_public_path__ + "img/pep.e7f61478.jpg";